import { create } from "zustand";
import { IGif } from "@/common/services/types";

interface IGifsState {
  gifs: IGif[];
  updateGifs: (incomingGifs: IGif[]) => void;
  getGifById: (gifId: string) => IGif | undefined;
}

// Utility function to merge and deduplicate GIFs
const mergeGifs = (existingGifs: IGif[] = [], incomingGifs: IGif[]): IGif[] => {
  const gifMap = new Map<string, IGif>(existingGifs.map((gif) => [gif.id, gif]));

  incomingGifs.forEach((gif) => {
    const oldGif = gifMap.get(gif.id) || {};

    // some properties of gifs as example `repost` dont send in other endpoints
    gifMap.set(gif.id, {
      ...oldGif,
      ...gif,
    });
  });

  return Array.from(gifMap.values());
};

export const useGifStore = create<IGifsState>(
  (set, get) => ({
    gifs: [],
    updateGifs: (incomingGifs: IGif[]) =>
      set((state) => ({
        gifs: mergeGifs(state.gifs, incomingGifs),
      })),
    getGifById: (gifId: string) => {
      const { gifs } = get();

      return gifs.find((gif) => gif.id === gifId || gif.aliasId === gifId);
    },
  }),
);
